import * as angular from "angular";
import * as _ from "lodash";
import {GlobalSearchItemsType} from "../../search/types/global-search-items.type";
import {DeliverySchedulingForm} from "../models/delivery-scheduling-form.model";
import {OmsOrdersAlertsService} from "./oms-orders-alerts.service";
import {IQService} from "angular";
import {SplitService} from "../../commons/services/split-service.service";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {GlobalSearchService} from "../../search/services/global-search-service.service";
import {OmsDialogService} from "./oms-dialog-service.service";
import {OmsRequestsService} from "./oms-requests.service";
import {SettingsAlertsService} from "../../site-preferences/services/settings-alerts.service";
import {ConfirmDialogService} from "../../commons/services/confirm-dialog.service";
import {CancellationReason} from "../../cancellation-reasons/models/cancellationReason.model";
import {
  OmsOrdersBulkExportRequestModel,
  OmsOrdersBulkMetadataRequestModel,
  OmsOrdersBulkTriggerSchedulingRequestModel,
  OmsOrdersBulkUpdateRequestModel
} from "../models/oms-orders-bulk-requests.model";
import {CommonsAlertsService} from "../../commons/services/commons-alerts.service";
import {OrderModel} from "../models/order.model";
import {OperationalContactModel} from "../../commons/angular/models/operational-contact.model";
import {SuperSearchSortMethodType} from "../../search/types/super-search-sort-method.type";

export class OmsService {

  constructor(private omsRequestsService: OmsRequestsService, private settingsAlertsService: SettingsAlertsService, private splitService: SplitService,
              private bringozLoaderService: BringozLoaderService, private $q: IQService, private commonsAlertsService: CommonsAlertsService,
              private globalSearchService: GlobalSearchService, private $log, private $omsOrder,
              private omsOrdersAlertsService: OmsOrdersAlertsService, private moment, private confirmDialogService: ConfirmDialogService, private omsDialogService: OmsDialogService) {
  }

  getOne(id) {
    this.bringozLoaderService.on();
    return this.$omsOrder(id).$instantGet()
      .then((order) => {
        return order;
      })
      .catch((error) => {
        this.$log.error('Failed to get order', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  getPricingOffer(order) {
    this.bringozLoaderService.on();
    return this.omsRequestsService.getPricingOffer(order)
      .then((orderSettings) => {
        return orderSettings;
      })
      .catch((error) => {
        this.$log.error('Failed to get orderSettings', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  onCancelOrder(orderId, event?) {
    const deferred = this.$q.defer();

    this.omsDialogService.createOrderCancellationReason(undefined)
      .then((orderCancellationReason: CancellationReason) => {
        this.bringozLoaderService.on();
        this.omsRequestsService.cancelOrder(orderId, orderCancellationReason)
          .then((canceledOrder) => {
            deferred.resolve(canceledOrder);
            this.omsOrdersAlertsService.cancelSuccess();
          })
          .catch((error) => {
            deferred.reject(error)
            this.omsOrdersAlertsService.cancelError();
          })
          .finally(() => {
            this.bringozLoaderService.off();
          });
      })
      .catch(() => {
        this.$log.debug('Closed Dialog');
      })


    return deferred.promise

  }

  getOmsMetadataSettings(metaData) {
    const omsLocalSettings = this.splitService.getSiteOmsSettings();
    const metadataCopy = _.chain(metaData)
      .filter((m) => {
        return m.holder === 'OMS' && !!m.active
      })
      .map((activeMetadata) => {
        const currentMetadataValue = _.find(omsLocalSettings.dynamicColumns, (c) => {
          return c.id === activeMetadata.id;
        });
        return {
          id: activeMetadata.id,
          key: activeMetadata.key,
          title: activeMetadata.title,
          enabled: _.get(currentMetadataValue, 'enabled', false) // enable on display
        }
      })
      .value();

    omsLocalSettings.dynamicColumns = metadataCopy;
    this.splitService.setSiteOmsSettings(omsLocalSettings);
    return metadataCopy;
  }

  update3plsSettings(settings) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.omsRequestsService.update3plsSettings(settings)
        .then((updatedSettings) => {
          resolve(updatedSettings);
        })
        .catch((error) => {
          this.settingsAlertsService.getGeneralTasksError();
          reject(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  assignToSupplier(orderId, supplier) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.omsRequestsService.assignToSupplier(orderId, supplier)
        .then((updatedSettings) => {
          resolve(updatedSettings);
        })
        .catch((error) => {
          this.settingsAlertsService.getGeneralTasksError();
          reject(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  onGetBOLOrderIdToPdf(orderId) {
    if (!orderId) {
      return;
    }
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.omsRequestsService.getPDFBolByOrderId(orderId)
      .then((bolFile) => {
        deferred.resolve(bolFile)
      })
      .catch((error) => {
        this.omsOrdersAlertsService.getBOLError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise

  }

  validateOmsOrderServiceAreas(order) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.omsRequestsService.validateServiceAreas(order)
      .then((isValid) => {
        deferred.resolve(isValid)
      })
      .catch((error) => {
        this.omsOrdersAlertsService.validateServiceAreasError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise

  }

  sendSchedulingLink(orderId, ignoreOrderStatus?) {

    this.bringozLoaderService.on();
    return this.omsRequestsService.sendSchedulingLink(orderId, ignoreOrderStatus)
      .then(() => {
        this.omsOrdersAlertsService.sendSchedulingMsgSuccess();
      })
      .catch((error) => {
        this.omsOrdersAlertsService.sendSchedulingMsgError();
        this.$log.error('Failed to send scheduling link', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  scheduleSelfPickup(orderId, selfPickup) {

    this.bringozLoaderService.on();
    return this.omsRequestsService.scheduleSelfPickup(orderId, selfPickup)
      .then(() => {
        this.omsOrdersAlertsService.createSuccess();
      })
      .catch((error) => {
        this.omsOrdersAlertsService.createError(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  sendSchedulingLinkWhatsapp(orderId, ignoreOrderStatus?) {

    this.bringozLoaderService.on();
    return this.omsRequestsService.sendSchedulingLinkWhatsapp(orderId, ignoreOrderStatus)
      .then(() => {
        this.omsOrdersAlertsService.sendSchedulingMsgSuccess();
      })
      .catch((error) => {
        this.omsOrdersAlertsService.sendSchedulingMsgError();
        this.$log.error('Failed to send scheduling link', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  bulkSendSchedulingLink(request: OmsOrdersBulkTriggerSchedulingRequestModel) {

    this.bringozLoaderService.on();
    return this.omsRequestsService.bulkSendSchedulingLink(request)
      .then(() => {
        this.omsOrdersAlertsService.sendSchedulingMsgSuccess();
      })
      .catch((error) => {
        this.omsOrdersAlertsService.sendSchedulingMsgError();
        this.$log.error('Failed to send scheduling link', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  bulkSendSchedulingLinkWhatsapp(request: OmsOrdersBulkTriggerSchedulingRequestModel) {

    this.bringozLoaderService.on();
    return this.omsRequestsService.bulkSendSchedulingLinkWhatsapp(request)
      .then(() => {
        this.omsOrdersAlertsService.sendSchedulingMsgSuccess();
      })
      .catch((error) => {
        this.omsOrdersAlertsService.sendSchedulingMsgError();
        this.$log.error('Failed to send scheduling link', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }


  getSchedulingForm(orderId: string): Promise<DeliverySchedulingForm> {

    this.bringozLoaderService.on();
    return this.omsRequestsService.getSchedulingForm(orderId)
      .catch((error) => {
        this.omsOrdersAlertsService.getSchedulingFormError();
        this.$log.error('Failed to get scheduling form', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }


  addNote(orderId, note) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.omsRequestsService.addNote(orderId, note)
      .then((res) => {
        this.omsOrdersAlertsService.addNoteSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.omsOrdersAlertsService.addNoteError();
        this.$log.error('Failed to get orderSettings', error);
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise
  }

  resumeOrder(orderId, isSendSchedulingFormToClient) {
    this.bringozLoaderService.on();
    return this.omsRequestsService.resumeOrder(orderId, isSendSchedulingFormToClient)
      .then(() => {
        this.omsOrdersAlertsService.resumeOrderSuccess();
      })
      .catch((error) => {
        this.omsOrdersAlertsService.resumeOrderError();
        this.$log.error('Failed to get orderSettings', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  manuallyCompleteOrder(orderId) {
    this.bringozLoaderService.on();
    return this.omsRequestsService.manuallyCompleteOrder(orderId)
      .then(() => {
        this.omsOrdersAlertsService.manuallyCompleteOrderSuccess();
      })
      .catch((error) => {
        this.omsOrdersAlertsService.manuallyCompleteOrderError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }


  getOrderInfo(orderId) {
    this.bringozLoaderService.on();
    return this.omsRequestsService.getOrderInfo(orderId)
      .then((orderSettings) => {
        return orderSettings;
      })
      .catch((error) => {
        this.$log.error('Failed to get orderSettings', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  getOrderTaskTimeSlots(accountId, depotId, lineType, from, to, programType, zoneId) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.omsRequestsService.getOrderTaskTimeSlots(accountId, depotId, lineType, from, to, programType, zoneId)
        .then(timeSlotsOptions => {
          resolve(timeSlotsOptions);
        })
        .catch((error) => {
          // this.OMSOrdersAlerts.getOrderTaskTimeSlotsError();
          reject(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  autoDispatchOrder(orderId) {
    this.bringozLoaderService.on();
    return this.omsRequestsService.autoDispatch(orderId)
      .catch((error) => {
        this.omsOrdersAlertsService.autoDispatchError(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  updateCompletedOrder(orderId, updatedOrder) {
    this.bringozLoaderService.on();
    const deferred = this.$q.defer();

    this.omsRequestsService.updateCompletedOrder(orderId, updatedOrder)
      .then((res) => {
        this.omsOrdersAlertsService.updateSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.omsOrdersAlertsService.updateError(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise

  }

  updateOperationalContacts(orderId: string, operationalContacts: OperationalContactModel[]) {
    this.bringozLoaderService.on();
    const deferred = this.$q.defer();

    this.omsRequestsService.updateOperationalContacts(orderId, operationalContacts)
      .then((res) => {
        this.omsOrdersAlertsService.updateSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.omsOrdersAlertsService.updateError(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise
  }

  isOrderTaskHoursWithinOperationHoursRange(operationHourFrom, operationHourTo, taskNotBefore, taskNotAfter) {
    return this.moment(taskNotBefore).isBetween(operationHourFrom, operationHourTo, null, '[]') &&
      this.moment(taskNotAfter).isBetween(operationHourFrom, operationHourTo, null, '[]');
  }

  swapOriginDestination(fulfillmentLine) {
    // swap contact
    const tempContact = fulfillmentLine.pickupTask.contact
    fulfillmentLine.pickupTask.contact = fulfillmentLine.destinationTask.contact;
    fulfillmentLine.destinationTask.contact = tempContact;

    // swap location
    const tempLocation = fulfillmentLine.pickupTask.location
    fulfillmentLine.pickupTask.location = fulfillmentLine.destinationTask.location;
    fulfillmentLine.destinationTask.location = tempLocation;

    // swap additions
    const tempPickupAdditions = _.get(fulfillmentLine.pickupTask, 'additions', undefined);
    const tempDestinationAdditions = _.get(fulfillmentLine.destinationTask, 'additions', undefined);

    tempPickupAdditions ? fulfillmentLine.destinationTask.additions = tempPickupAdditions : _.unset(fulfillmentLine.destinationTask.additions, 'additions');
    tempDestinationAdditions ? fulfillmentLine.pickupTask.additions = tempDestinationAdditions : _.unset(fulfillmentLine.pickupTask.additions, 'additions');

    // swap notes
    const tempPickupNotes = _.get(fulfillmentLine.pickupTask, 'notes', undefined);
    const tempDestinationNotes = _.get(fulfillmentLine.destinationTask, 'notes', undefined);

    tempPickupNotes ? fulfillmentLine.destinationTask.notes = tempPickupNotes : _.unset(fulfillmentLine.destinationTask.notes, 'notes');
    tempDestinationNotes ? fulfillmentLine.pickupTask.notes = tempDestinationNotes : _.unset(fulfillmentLine.pickupTask.notes, 'notes');

    // //swap identifications
    // const tempPickupIdentifications = _.get(fulfillmentLine.pickupTask,'identifications',undefined);
    // const tempDestinationIdentifications = _.get(fulfillmentLine.destinationTask,'identifications',undefined);
    //
    // tempPickupIdentifications? fulfillmentLine.destinationTask.identifications=tempPickupIdentifications: _.unset(fulfillmentLine.destinationTask.identifications, 'identifications');
    // tempDestinationIdentifications? fulfillmentLine.pickupTask.identifications=tempDestinationIdentifications: _.unset(fulfillmentLine.pickupTask.identifications, 'identifications');
  }

  createReturnDeliveryOrder(currentOrderId, duplicatedFulfillmentLineId, newOrder) {
    this.bringozLoaderService.on();
    const deferred = this.$q.defer();

    this.omsRequestsService.createReturnDeliveryOrder(currentOrderId, duplicatedFulfillmentLineId, newOrder)
      .then((res) => {
        this.omsOrdersAlertsService.createSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.omsOrdersAlertsService.createError(error);
        deferred.reject(error)
        this.$log.info('Failed to create new order', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }


  updateOrder(order) {
    this.bringozLoaderService.on();
    this.omsRequestsService.updateOrder(order.id, order)
      .then(() => {
        this.omsOrdersAlertsService.updateSuccess();
      })
      .catch((error) => {
        this.omsOrdersAlertsService.updateError(error);
        this.$log.info('Failed to update order PRO number', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  getLogsTimeline(orderId) {
    this.bringozLoaderService.on();
    return this.omsRequestsService.getLogsTimeline(orderId)
      .catch(() => {
        this.omsOrdersAlertsService.getTimelineError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  getGlobalSearch(query: string, limit: number = 10, autoComplete: boolean = true, sortMethod?: SuperSearchSortMethodType) {
    this.bringozLoaderService.on();
    return this.omsRequestsService.getGlobalSearch(query, limit, autoComplete, sortMethod)

      .then(orders => {
        return this.globalSearchService.itemToItemOfType(orders, GlobalSearchItemsType.Orders);
      })
      .catch(() => {
        this.omsOrdersAlertsService.getGlobalSearchError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  recoverOrder(orderId) {
    this.bringozLoaderService.on();
    const deferred = this.$q.defer();

    this.omsRequestsService.recoverOrder(orderId)
      .then((res) => {
        this.omsOrdersAlertsService.recoverSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.omsOrdersAlertsService.recoverError(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise
  }

  onAddNote(event, orderId) {
    this.omsDialogService.addNote(event, orderId)
      .then((note) => {
        this.addNote(orderId, note);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed');
      })
  }

  onSetOrderOnHold(orderId) {
    const deferred = this.$q.defer();

    this.omsDialogService.onSetOrderOnHold().then((description) => {
      this.bringozLoaderService.on();
      this.omsRequestsService.setOrderOnHold(orderId, description)
        .then((res) => {
          deferred.resolve(res);
          this.omsOrdersAlertsService.setOrderOnHoldSuccess();
        })
        .catch((error) => {
          if (error.code === 400404) {
            this.omsOrdersAlertsService.cannotSetOrderOnHoldError(error);
          } else {
            this.omsOrdersAlertsService.setOrderOnHoldError();
            this.$log.error('Failed to set order on hold', error);
          }
          deferred.reject(error)
        })
        .finally(() => {
          this.bringozLoaderService.off();
        })
    })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })

    return deferred.promise
  }

  emailBOL(emailRecipients: string[], note: string, orderId) {
    this.bringozLoaderService.on();
    const deferred = this.$q.defer();

    this.omsRequestsService.emailBOL(emailRecipients, note, orderId)
      .then((res) => {
        this.omsOrdersAlertsService.emailBOLSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.omsOrdersAlertsService.emailBOLError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise
  }

  cancelFulfillmentLines(orderId: string, lineIds: string[]) {
    this.bringozLoaderService.on();
    const deferred = this.$q.defer();

    this.omsRequestsService.cancelFulfillmentLines(orderId, lineIds)
      .then((res) => {
        this.omsOrdersAlertsService.cancelFulfillmentLinesSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.omsOrdersAlertsService.cancelFulfillmentLinesError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise
  }

  bulkUpdateOrders(request: OmsOrdersBulkUpdateRequestModel) {
    this.bringozLoaderService.on();
    const deferred = this.$q.defer();

    this.omsRequestsService.bulkUpdate(request)
      .then((res) => {
        this.omsOrdersAlertsService.bulkUpdateOrdersSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        if (error.code === 412001) {
          this.omsOrdersAlertsService.bulkUpdateOrdersError();

        } else {
          this.omsOrdersAlertsService.bulkUpdateOrdersError();
        }
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise
  }

  onDeleteOrderNote(orderId, noteId) {

    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.omsRequestsService.deleteNote(orderId, noteId)
      .then(() => {
        this.omsOrdersAlertsService.deleteOrderNoteSuccess();
      })
      .catch((error) => {
        this.omsOrdersAlertsService.deleteOrderNoteError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise

  }

  exportOrdersTable(sort: string, request: OmsOrdersBulkExportRequestModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.omsRequestsService.exportOrdersTable(sort, request)
      .then((response) => {
        this.omsOrdersAlertsService.exportOmsOrdersTableSuccess();
        deferred.resolve(response);
      })
      .catch((error) => {
        this.omsOrdersAlertsService.exportOmsOrdersTableError();
        this.$log.error('Failed to export Oms Orders', error);
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }

  checkOrderEditStatus(omsEditableStatus): {
    isEditable: boolean,
    reasons: string[]
  } {
    let reasons: string[] = [];
    let isEditable: boolean = true;

    const omsEditableStatusConfiguration = this.splitService.getOmsEditableStatusConfiguration() || {};

    const omsEditableStatusConfigurationMap = {
      'isPendingInvoiceOrInvoiced': 'disableEditingInvoicedOmsOrder'
    }
    Object.keys(omsEditableStatus || {}).forEach((key: string) => {
      if (omsEditableStatus[key] && omsEditableStatusConfiguration[omsEditableStatusConfigurationMap[key]]) {
        isEditable = false;
        reasons.push(key);
      }
    });

    return {
      isEditable: isEditable,
      reasons: reasons
    };

  }

  updateOrderMetaData(orderId: string, metaData: {key: string, value: string}[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.omsRequestsService.updateOrderMetaData(orderId, metaData)
      .then((order: OrderModel) => {
        this.commonsAlertsService.updateMetaDataSuccess();
        deferred.resolve(order);
      })
      .catch((error) => {
        this.commonsAlertsService.updateMetaDataError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateOrdersMetaData(request: OmsOrdersBulkMetadataRequestModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.omsRequestsService.updateOrdersMetaData(request)
      .then((orders: OrderModel[]) => {
        this.commonsAlertsService.updateMetaDataSuccess();
        deferred.resolve(orders);
      })
      .catch((error) => {
        this.commonsAlertsService.updateMetaDataError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }


}

angular
  .module('bringoz.admin.oms')
  .service('omsService', OmsService);
